import React from "react"

import { TagFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchTag {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: TagFilters
    onFilter: (filters: TagFilters) => void
}

const TagSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchTag) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default TagSearch
